export default __webpack_public_path__ + "static/media/empty-beranda.a513c2d1.png";